<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    ></qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getAddressOptions,
} from '@qx/utils';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        vehicleClassOptions: [],
        form: [{
          label: '订单号',
          value: 'orderId',
          type: 'input',
          placeholder: '请输入订单号',
        },
        {
          label: '线路起点',
          value: 'sourceRegion',
          type: 'cascader',
          options: getAddressOptions({
            showLevel: 1,
          }),
        },
        {
          label: '线路终点',
          value: 'destRegion',
          type: 'cascader',
          options: getAddressOptions({
            showLevel: 1,
          }),
        }, {
          label: '车牌号',
          value: 'plateNumber',
          type: 'input',
          placeholder: '请输入车牌号',
        }, {
          label: '司机姓名',
          value: 'carUserName',
          type: 'input',
          placeholder: '请输入司机姓名',
        }, {
          label: '司机手机',
          value: 'carUserPhone',
          type: 'input',
          placeholder: '请输入司机手机',
        }, {
          label: '发车时间',
          value: 'DependTime',
          type: 'date',
          placeholder: '选择发车时间',
          default: [],
          attr: {
            type: 'daterange',
          },
        }],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.DependTime.length) {
        searchBoxData.endDependTime = searchBoxData.DependTime[0];
        searchBoxData.endDependTime = searchBoxData.DependTime[1];
      }
      if (searchBoxData.sourceRegion.length) {
        searchBoxData.sourceRegion = searchBoxData.sourceRegion[0]; // 省
      }
      if (searchBoxData.destRegion.length) {
        searchBoxData.destRegion = searchBoxData.destRegion[0]; // 省
      }
      console.log(this.$route.query.id);
      searchBoxData.trailerPlate = decodeURI(this.$route.query.id);
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
